module.exports = __webpack_public_path__ + "static/media/bq.559038bc.svg";